module.exports = [4, 50, 11, 35];